import type { IconProps } from '../../types/icon-props';

export const EmptyItem = (props: IconProps) => {
  const { ...rest } = props;

  return (
    <svg
      width={105}
      height={105}
      viewBox="0 0 105 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame">
        <g id="Group">
          <path
            id="Vector"
            d="M93.0298 15.4221V96.0185C93.0298 99.4354 90.2598 102.205 86.843 102.205H31.2883C27.8716 102.205 25.1016 99.4352 25.1016 96.0185V15.4221C25.1016 12.0054 27.8716 9.23535 31.2883 9.23535H86.843C90.2598 9.23535 93.0298 12.0052 93.0298 15.4221Z"
            fill="white"
          />
          <path
            id="Vector_2"
            d="M87.7285 21.7139V89.7264C87.7285 92.6098 85.3912 94.9472 82.5078 94.9472H35.627C32.7436 94.9472 30.4062 92.6098 30.4062 89.7264V21.7139C30.4062 18.8305 32.7436 16.4932 35.627 16.4932H82.5076C85.3912 16.4932 87.7285 18.8305 87.7285 21.7139Z"
            fill="white"
          />
          <path
            id="Vector_3"
            d="M93.0361 15.4175V96.0227C93.0361 99.4308 90.2621 102.205 86.8441 102.205H78.8984C82.3065 102.205 85.0805 99.4308 85.0805 96.0227V15.4175C85.0805 12.0094 82.3065 9.23535 78.8984 9.23535H86.8441C90.2621 9.23535 93.0361 12.0094 93.0361 15.4175Z"
            fill="black"
            fillOpacity="0.08"
          />
          <path
            id="Vector_4"
            d="M66.2974 57.0252V73.6916C66.2974 76.6202 63.9232 78.9945 60.9944 78.9945H30.8811C27.9525 78.9945 25.5781 76.6204 25.5781 73.6916V57.0252C25.5781 54.0965 27.9523 51.7222 30.8811 51.7222H60.9944C63.923 51.7222 66.2974 54.0963 66.2974 57.0252Z"
            fill="white"
          />
          <path
            id="Vector_5"
            d="M79.897 15.4221V96.0185C79.897 99.4354 77.127 102.205 73.7102 102.205H18.1555C14.7388 102.205 11.9688 99.4352 11.9688 96.0185V15.4221C11.9688 12.0054 14.7388 9.23535 18.1555 9.23535H73.7102C77.1272 9.23535 79.897 12.0052 79.897 15.4221Z"
            fill="white"
          />
          <path
            id="Vector_6"
            d="M79.9063 15.4175V96.0227C79.9063 99.4308 77.1323 102.205 73.7143 102.205H58.1797C61.5977 102.205 64.3718 99.4308 64.3718 96.0227V15.4175C64.3718 12.0094 61.5977 9.23535 58.1797 9.23535H73.7143C77.1323 9.23535 79.9063 12.0094 79.9063 15.4175Z"
            fill="black"
            fillOpacity="0.08"
          />
          <path
            id="Vector_7"
            d="M43.1627 8.53045V33.6698C43.1627 35.0478 41.6224 35.8658 40.4808 35.0937L32.2727 29.5423L24.0647 35.0937C22.9231 35.8658 21.3828 35.048 21.3828 33.6698V8.53045C21.3828 5.54939 23.7994 3.13281 26.7805 3.13281H37.7652C40.7461 3.13281 43.1627 5.54939 43.1627 8.53045Z"
            fill="#EE2D58"
          />
          <path
            id="Vector_8"
            d="M43.164 8.53228V33.667C43.164 35.0442 41.6185 35.8664 40.4791 35.0935L36.001 32.0619V8.53228C36.001 5.5502 33.5836 3.13281 30.6016 3.13281H37.7646C40.7466 3.13281 43.164 5.5502 43.164 8.53228Z"
            fill="black"
            fillOpacity="0.08"
          />
          <path
            id="Vector_9"
            d="M66.2974 57.0252V73.6916C66.2974 76.6202 63.9232 78.9945 60.9944 78.9945H30.8811C27.9525 78.9945 25.5781 76.6204 25.5781 73.6916V57.0252C25.5781 54.0965 27.9523 51.7222 30.8811 51.7222H60.9944C63.923 51.7222 66.2974 54.0963 66.2974 57.0252Z"
            fill="white"
          />
          <path
            id="Vector_10"
            d="M66.2933 57.0281V73.692C66.2933 76.6246 63.9254 78.9924 60.9929 78.9924H50.8281C53.7606 78.9924 56.1285 76.6246 56.1285 73.692V57.0281C56.1285 54.0956 53.7606 51.7178 50.8281 51.7178H60.9929C63.9254 51.7178 66.2933 54.0954 66.2933 57.0281Z"
            fill="black"
            fillOpacity="0.08"
          />
          <g id="Group_2">
            <path
              id="Vector_11"
              d="M10.7344 96.0186C10.7344 100.113 14.0654 103.444 18.1594 103.444H86.8455C90.9395 103.444 94.2705 100.113 94.2705 96.0186V15.422C94.2705 11.3281 90.9395 7.99702 86.8455 7.99702H44.3707C44.0972 4.58716 41.2405 1.89453 37.7616 1.89453H26.777C23.2979 1.89453 20.4413 4.58716 20.1679 7.99702H18.1594C14.0654 7.99702 10.7344 11.3281 10.7344 15.422V96.0186ZM81.1397 17.7316H82.5082C84.7044 17.7316 86.4909 19.5181 86.4909 21.7143V89.7264C86.4909 91.9226 84.7044 93.7091 82.5082 93.7091H81.1397V17.7316ZM91.7938 15.422V96.0186C91.7938 98.747 89.5739 100.967 86.8455 100.967H79.2346C80.3796 99.6909 81.09 98.0216 81.1312 96.186H82.5082C86.07 96.186 88.9678 93.2882 88.9678 89.7264V21.7143C88.9678 18.1525 86.0702 15.2547 82.5082 15.2547H81.1312C81.09 13.4192 80.3796 11.7498 79.2346 10.4737H86.8455C89.5739 10.4737 91.7938 12.6937 91.7938 15.422ZM22.6178 8.53062C22.6178 6.23714 24.4837 4.37123 26.7772 4.37123H37.7618C40.0553 4.37123 41.9212 6.23714 41.9212 8.53062V33.6698C41.9212 34.0557 41.4936 34.2852 41.1714 34.0679L32.9632 28.5163C32.7537 28.3745 32.5118 28.3038 32.2695 28.3038C32.0272 28.3038 31.7852 28.3749 31.5758 28.5167L23.3679 34.0677C23.0496 34.2834 22.6182 34.0586 22.6182 33.6696V8.53062H22.6178ZM13.2113 15.422C13.2113 12.6937 15.4312 10.4737 18.1596 10.4737H20.1411V33.6696C20.1411 36.0407 22.799 37.4471 24.7551 36.1193L32.2693 31.0375L39.7839 36.1199C41.7453 37.4465 44.3979 36.038 44.3979 33.6696V10.4737H73.7143C76.4431 10.4737 78.663 12.6937 78.663 15.422V96.0186C78.663 98.747 76.4431 100.967 73.7143 100.967H18.1596C15.4312 100.967 13.2113 98.747 13.2113 96.0186V15.422Z"
              fill="#4B4B55"
            />
            <path
              id="Vector_12"
              d="M30.8772 80.2327H60.9902C64.5975 80.2327 67.5321 77.2983 67.5321 73.6914V57.0252C67.5321 53.4179 64.5977 50.4834 60.9902 50.4834H30.8772C27.2703 50.4834 24.3359 53.4177 24.3359 57.0252V73.6914C24.3359 77.2983 27.2703 80.2327 30.8772 80.2327ZM26.8126 57.0252C26.8126 54.784 28.6359 52.9603 30.8772 52.9603H60.9902C63.2315 52.9603 65.0552 54.784 65.0552 57.0252V73.6914C65.0552 75.9327 63.2315 77.756 60.9902 77.756H30.8772C28.6359 77.756 26.8126 75.9327 26.8126 73.6914V57.0252Z"
              fill="#4B4B55"
            />
            <path
              id="Vector_13"
              d="M32.2697 60.473H60.2049C60.889 60.473 61.4433 59.9187 61.4433 59.2345C61.4433 58.5504 60.889 57.9961 60.2049 57.9961H32.2697C31.9412 57.9961 31.6262 58.1266 31.394 58.3588C31.1617 58.5911 31.0312 58.9061 31.0312 59.2345C31.0312 59.563 31.1617 59.878 31.394 60.1103C31.6262 60.3425 31.9412 60.473 32.2697 60.473ZM32.2697 70.5738H51.1142C51.4427 70.5738 51.7577 70.4433 51.9899 70.2111C52.2222 69.9788 52.3527 69.6638 52.3527 69.3353C52.3527 69.0069 52.2222 68.6919 51.9899 68.4596C51.7577 68.2274 51.4427 68.0969 51.1142 68.0969H32.2697C31.9412 68.0969 31.6262 68.2274 31.394 68.4596C31.1617 68.6919 31.0312 69.0069 31.0312 69.3353C31.0312 69.6638 31.1617 69.9788 31.394 70.2111C31.6262 70.4433 31.9412 70.5738 32.2697 70.5738Z"
              fill="#4B4B55"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

EmptyItem.displayName = 'EmptyItem';
